import { render, staticRenderFns } from "./ApplicantOnboardingIdentifiers.vue?vue&type=template&id=7cbf0458&"
import script from "./ApplicantOnboardingIdentifiers.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingIdentifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports